import { PersonsCatalog } from '@/components/PersonsCatalog'

interface MemberPermissions {
  canManagePersons: boolean
  canManageClassifications: boolean
}

interface PersonsTabProps {
  groupId: string
  onNavigateToSightings?: (personId: string, sightingId?: string, personName?: string) => void
  permissions?: MemberPermissions | null
  urlPersonId?: string | null
  isAdmin?: boolean
}

export function PersonsTab({ groupId, onNavigateToSightings, permissions, urlPersonId, isAdmin = false }: PersonsTabProps) {
  return (
    <PersonsCatalog
      groupId={groupId}
      onNavigateToSightings={onNavigateToSightings}
      canManagePersons={permissions?.canManagePersons ?? true}
      urlPersonId={urlPersonId}
      isAdmin={isAdmin}
    />
  )
}
